import { buildAuthHeaders } from "../forum/authHeaders";
import { REMAINING_MISSIONS_COUNT_ENDPOINT } from "./rubricRegistry";

export class RemainingMissionsApiError extends Error {
  constructor(message, status = null) {
    super(message);
    this.name = "RemainingMissionsApiError";
    this.status = status;
  }
}

function parseCount(payload) {
  const raw =
    payload?.remaining_count ?? payload?.count ?? payload?.active_count ?? null;
  const value = Number(raw);
  if (raw == null || !Number.isFinite(value) || value < 0) return null;
  return Math.trunc(value);
}

export async function fetchRemainingMissionsCount(rubricId, { signal } = {}) {
  const params = new URLSearchParams();
  params.set("rubric", String(rubricId || ""));
  params.set("count_only", "1");

  const response = await fetch(
    `${REMAINING_MISSIONS_COUNT_ENDPOINT}?${params.toString()}`,
    {
      method: "GET",
      headers: buildAuthHeaders({ Accept: "application/json" }),
      signal,
    }
  );

  let payload = null;
  try {
    payload = await response.json();
  } catch (_error) {
    payload = null;
  }

  if (!response.ok) {
    throw new RemainingMissionsApiError(
      String(
        payload?.detail ||
          payload?.error ||
          "Le compteur de missions est momentanément indisponible."
      ),
      response.status
    );
  }

  const count = parseCount(payload);
  return {
    available: count !== null,
    count,
    rubric: String(payload?.rubric || rubricId || ""),
  };
}
